export default "__VITE_ASSET__DoAcdbvh__"